<!-- =========================================================================================
  File Name: VehicleEdit.vue
  Description: Vehicle Create Page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
	<div id="page-user-edit">
		<vx-card>
			<vs-alert color="danger" :title="$t('Vehicles.VehicletNotFound.Title')" :active.sync="vehicle_not_found">
				<span>{{
					$t("Vehicles.VehicletNotFound.Text1") +
					" " +
					$route.params.id +
					" " +
					$t("Vehicles.VehicletNotFound.Text2")
				}}</span>
				<span>
					<span>{{ $t("Check") }} </span>
					<router-link :to="{name: 'app-vehicle-list'}" class="text-inherit underline">{{
						$t("Vehicles.AllVehicles")
					}}</router-link>
				</span>
			</vs-alert>
			<vehicle-edit-tab-account
				v-if="vehiclesInfo !== null && vehicleUpdatePermission"
				class="mt-4"
				:data="vehiclesInfo"
			/>
			<not-permission v-if="!vehicleUpdatePermission"></not-permission>
		</vx-card>
	</div>
</template>

<script>
import NotPermission from "@/views/pages/NotPermission.vue";
import moduleCapacity from "@/store/capacity/moduleCapacity.js";
import moduleSkills from "@/store/skills/moduleSkills.js";
import moduleTeams from "@/store/teams/moduleTeams.js";
import moduleBreaks from "@/store/breaks/moduleBreaks.js";
import VehicleEditTabAccount from "./VehicleEditTabAccount.vue";

export default {
	components: {
		NotPermission,
		VehicleEditTabAccount,
	},
	data() {
		return {
			vehiclesInfo: null,
			vehicle_not_found: false,
			capacityList: [],
		};
	},
	computed: {
		vehicleUpdatePermission() {
			return this.$store.getters.checkPermission("VEHICLE_U");
		},
	},
	methods: {
		openLoading() {
			this.$vs.loading();
		},
		closeLoading() {
			this.$vs.loading.close();
		},
		getVehicleById(vehicleId) {
			this.openLoading();
			this.$store
				.dispatch("vehicle/findVehiclePaginated", {id: [vehicleId]})
				.then((res) => {
					this.vehiclesInfo = res.records[0];
					this.closeLoading();
					return res.records;
				})
				.catch((err) => {
					this.closeLoading();
					this.vehicle_not_found = true;
					console.error(err);
				});
		},
	},
	created() {
		if (!moduleCapacity.isRegistered) {
			this.$store.registerModule("moduleCapacity", moduleCapacity);
			moduleCapacity.isRegistered = true;
		}
		if (!moduleSkills.isRegistered) {
			this.$store.registerModule("moduleSkills", moduleSkills);
			moduleSkills.isRegistered = true;
		}
		if (!moduleTeams.isRegistered) {
			this.$store.registerModule("moduleTeams", moduleTeams);
			moduleTeams.isRegistered = true;
		}
		if (!moduleBreaks.isRegistered) {
			this.$store.registerModule("moduleBreaks", moduleBreaks);
			moduleBreaks.isRegistered = true;
		}
		this.getVehicleById(parseInt(this.$route.params.id));
	},
	beforeDestroy() {
		this.$store.commit("moduleCapacity/REMOVE_ALL_ASSIGNED_CAPACITY");
		this.$store.commit("moduleSkills/REMOVE_ALL_ASSIGNED_SKILL");
		this.$store.commit("moduleTeams/CLEAN_ASSIGNED_TEAMS");
		this.$store.commit("moduleBreaks/CLEAN_ASSIGNED_BREAKS");
	},
};
</script>

<style lang="scss" scoped>
#page-user-edit {
	height: 30%;
}
</style>
